import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import './maxtropy-theme/maxtropy.less';
import App from './App/App';

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js